import $ from 'jquery';
import 'bootstrap-datepicker';
import isSameDay from 'date-fns/isSameDay';
import isBefore from 'date-fns/isBefore';
import dateAdd from 'date-fns/add';

function getArrowTemplate(className) {
  return `<button class="datepicker-button ${className}" type="button">
    <svg class="datepicker-icon ${className}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.719 96.004" xml:space="preserve"><path d="M47.178 96.004a9.539 9.539 0 0 1-6.63-2.67l-36.07-34.8c-5.816-5.601-5.989-14.857-.388-20.672.127-.132.256-.261.388-.388l36.07-34.8c3.794-3.659 9.836-3.549 13.495.245 3.659 3.794 3.549 9.836-.245 13.495l-32.75 31.59 32.75 31.59a9.54 9.54 0 0 1-6.62 16.41z"/></svg>
  </button>`;
}

function getStartDate() {
  const min = new Date(2021, 6, 1);
  const now = new Date();
  if (isBefore(now, min)) {
    return min;
  }
  return now;
}

function beforeShowDay(date) {
  if (isSameDay(date, this.startDate)) {
    return 'start';
  }
}

function handleChangeDate() {
  const $form = $(this).closest('.js-booking-form');
  const $formArrival = $form.find('[name="arrivalDate"]');
  const $formDeparture = $form.find('[name="departureDate"]');
  const arrivalDate = $formArrival.datepicker('getDate');
  const departureDate = $formDeparture.datepicker('getDate');

  if (!arrivalDate) {
    return;
  }

  const departureStartDate = dateAdd(arrivalDate, { days: 1 });
  $formDeparture.addClass('has-start-date');
  $formDeparture.datepicker('setStartDate', departureStartDate);

  // Ensure that the departureDate defaults to arrivalDate + 1
  if (!departureDate) {
    $formDeparture.datepicker('setDate', departureStartDate);
  }

  // Ensure that the departureDate is after the arrivalDate
  if (isBefore(departureDate, arrivalDate)) {
    $formDeparture.datepicker('setDate', departureStartDate);
  }
}

$('.js-booking-datepicker').each((index, datepicker) => {
  const $datepicker = $(datepicker);
  $datepicker.datepicker({
    autoclose: true,
    beforeShowDay,
    container: `[data-datepicker-container="${$datepicker.attr('id')}"]`,
    format: 'yyyy-mm-dd',
    maxViewMode: 2,
    startDate: getStartDate(),
    templates: {
      leftArrow: getArrowTemplate('is-left'),
      rightArrow: getArrowTemplate('is-right'),
    },
    todayHighlight: true,
  });
  $datepicker.on('changeDate', handleChangeDate);
});
